import { createSelector } from "reselect";

export const selectUsers = (state) => state?.usersPage?.users;
export const selectUsersModal = (state) => state?.usersPage?.modal;
export const selectUsersVariables = (state) => state?.usersPage?.variables;
export const selectVariablesGlobal = (state) =>
  state?.usersPage?.globalVariables;
export const selectUsersXVariables = (state) =>
  state?.usersPage?.usersXVariables;
export const selectUsersXMenu = (state) => state?.usersPage?.usersXMenu;
export const selectMenus = (state) => state?.usersPage?.menus;
export const selectUsersXStores = (state) => state?.usersPage?.usersXStore;
export const selectStores = (state) => state?.usersPage?.stores;

export const seletorStore = createSelector(selectStores, (stores) => {
  return stores.map((store) => [store.id, store.loja]);
});

export const seletorMenu = createSelector(selectMenus, (menus) => {
  return menus.map((menu) => [menu.id, menu.nome]);
});
